import React, { PropsWithChildren } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { getIsCustomMfaCompleted } from '../../../store/slice'

const CustomMfaAuthenticatedTemplate: React.FC<PropsWithChildren> = ({ children }) => {
  const isCustomMfaCompleted = useAppSelector(getIsCustomMfaCompleted)
  return <>{isCustomMfaCompleted && <>{children}</>}</>
}

const CustomMfaUnAuthenticatedTemplate: React.FC<PropsWithChildren> = ({ children }) => {
  const isCustomMfaCompleted = useAppSelector(getIsCustomMfaCompleted)
  return <>{!isCustomMfaCompleted && <>{children}</>}</>
}

export { CustomMfaAuthenticatedTemplate, CustomMfaUnAuthenticatedTemplate }
